// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f30500ca","201":"e5f53f13","279":"d4931e3c","291":"0d5fc7d4","377":"c8d75b9c","418":"605427ea","491":"8feeb1d3","624":"4b460e21","809":"5c45c0e3","881":"8e8c5d52","922":"40eb8c17"}[chunkId] + ".chunk.js";
};